import { gql } from '@apollo/client';
import { forPaginated } from './common/paginated.graphql';
import { HandlingUnit } from '../types/handling_unit/handlingUnit';
import {
  CreateHandlingUnitInput,
  DeleteHandlingUnitInput,
  UpdateHandlingUnitInput,
} from '../types/handling_unit/handlingUnit.input';

const handlingUnit = gql`
  fragment HandlingUnit on HandlingUnit {
    id
    version
    companyId
    productMasterDataId
    parentId
    quantity
    default
  }
`;

const get = gql`
  query HandlingUnits($page: Float) {
    handlingUnits(page: $page) {
      data {
        ...HandlingUnit
      }
      page
      pageSize
      batchSize
      hasNext
    }
  }
  ${handlingUnit}
`;

export interface GetHandlingUnitsVariables {
  page?: number;
}

export interface GetHandlingUnitsResponse {
  handlingUnits: PaginatedHandlingUnits;
}

class PaginatedHandlingUnits extends forPaginated<HandlingUnit>() {}

const create = gql`
  mutation CreateHandlingUnit($handlingUnits: [CreateHandlingUnitInput!]!) {
    createHandlingUnit(handlingUnits: $handlingUnits) {
      ...HandlingUnit
    }
  }
  ${handlingUnit}
`;

export interface CreateHandlingUnitVariables {
  handlingUnits: CreateHandlingUnitInput[];
}

export interface CreateHandlingUnitResponse {
  createHandlingUnit: HandlingUnit[];
}

const update = gql`
  mutation UpdateHandlingUnit($handlingUnits: [UpdateHandlingUnitInput!]!) {
    updateHandlingUnit(handlingUnits: $handlingUnits) {
      ...HandlingUnit
    }
  }
  ${handlingUnit}
`;

export interface UpdateHandlingUnitVariables {
  handlingUnits: UpdateHandlingUnitInput[];
}

export interface UpdateHandlingUnitResponse {
  updateHandlingUnit: HandlingUnit[];
}

const remove = gql`
  mutation DeleteHandlingUnit($handlingUnits: [DeleteHandlingUnitInput!]!) {
    deleteHandlingUnit(handlingUnits: $handlingUnits) {
      ...HandlingUnit
    }
  }
  ${handlingUnit}
`;

export interface DeleteHandlingUnitVariables {
  handlingUnits: DeleteHandlingUnitInput[];
}

export interface DeleteHandlingUnitResponse {
  deleteHandlingUnit: HandlingUnit[];
}

export const HandlingUnitQueries = {
  get,
};

export const HandlingUnitMutations = {
  create,
  update,
  remove,
};

export const HandlingUnitFragments = {
  handlingUnit,
};
